module.exports = __webpack_public_path__ + "img/foto_entrada.19572cd9.jpg";